import { z } from 'zod'
import { widgetSchema } from '../../common/schema'
import { specsParamsSchema } from './data'

export const specsWidgetConfig = widgetSchema.extend({
  section: z.object({
    show: z.boolean().default(false).describe('Show the section title above the widget content'),
    title: z.string().nullish().default('Rooms and Beds').describe('Section title text'),
  }).default({ show: false, title: 'Rooms and Beds' }).describe('Section heading shown above the widget content'),
  filter: specsParamsSchema,
  showAreaSize: z.boolean().default(false).describe('Show the property area size (when available) as a fourth column'),
  icons: z.object({
    bedrooms: z.string().default('icon-beds').describe('The icon class name for the bedrooms'),
    bathrooms: z.string().default('icon-bathrooms').describe('The icon class name for the bathrooms'),
    guests: z.string().default('icon-user').describe('The icon class name for the guests'),
    areaSize: z.string().default('icon-area').describe('The icon class name for the area size'),
  }).default({
    bedrooms: 'icon-beds',
    bathrooms: 'icon-bathrooms',
    guests: 'icon-user',
    areaSize: 'icon-area',
  }).describe('The icons of the widget'),
  translations: z.object({
    bedrooms: z.record(z.string(), z.string()).default({
      en_US: 'Bedrooms',
    }).describe('The bedrooms text translation for different languages'),
    bathrooms: z.record(z.string(), z.string()).default({
      en_US: 'Bathrooms',
    }).describe('The bathrooms text translation for different languages'),
    guests: z.record(z.string(), z.string()).default({
      en_US: 'Guests',
    }).describe('The guests text translation for different languages'),
    areaSize: z.record(z.string(), z.string()).default({
      en_US: 'Area',
    }).describe('The area size label translation for different languages'),
    studio: z.record(z.string(), z.string()).default({
      en_US: 'Studio',
    }).describe('Label shown instead of Bedrooms when the property has zero bedrooms'),
  }).default({
    bedrooms: { en_US: 'Bedrooms' },
    bathrooms: { en_US: 'Bathrooms' },
    guests: { en_US: 'Guests' },
    areaSize: { en_US: 'Area' },
    studio: { en_US: 'Studio' },
  }).describe('Widget translations'),
})

export type SpecsWidgetConfig = z.infer<typeof specsWidgetConfig>
